import React from 'react';// eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './PasswordPage.scss';
import reactMixin from 'react-mixin';
import baseComponent from '../../decorators/baseComponent';
import { connect } from 'react-redux';
import Header from '../Header';
import Context from '../../Context';
import BaseReactComponent from '../Util/BaseReactComponent';
import PasswordInput from 'react-password-input';
import {savePassword} from '../../actioncreators/LoginActions';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { Form } from 'react-bootstrap-validation';
import Password from 'try-react-password-input';



@connect(state => ({
    user: state.login.user
}))
@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin) class PasswordPage extends BaseReactComponent {

    constructor(props) {
        super(props);

        this.state = {};
        this.state.newPassword = '';
        this.state.newPasswordValid = false;
        this.state.confirmPassword = '';
    }

    keyup(e) {
        if (e.which === 13) {
            this.changePassword(e);
        }
    }

    changePassword(v) {
        let self = this;

        const id = this.props.location.query.id;
        const token = this.props.location.query.token;

        if (this.state.newPassword !== this.state.confirmPassword) {
            this.props.dispatch({
                type: 'CHANGE_PASSWORD_ERROR',
                text: this.getIntlMessage('error.password.dontmatch'),
                level: 'error',
                timeout: 5000
            })
        } else {

            savePassword(id, token, this.state.newPassword, function (err) {
                if (!err) {
                    location.assign('/');
                }
            })(self.props.dispatch);

        }
    }

    handleNewPasswordChange = (valid, newPassword) => {
      this.setState({
        newPassword: newPassword,
        newPasswordValid: valid,
        confirmPassword: this.state.confirmPassword
      });
    };

    render() {
        let title = 'Wachtwoord wijzigen';
        Context.getInstance().onSetTitle(title);

        let items = [{
            'path': '/login',
            'name': 'home',
            'role': 'USER'
        }];

        return (
            <div className="PasswordPage">
                <Header pageName="changepasswordpage" items={items}/>

                <div className="PasswordPage-container">
                    <div className="container">
                        <div className="row">
                            <div className="PasswordPage-container-background col-sm-4 col-md-offset-4">
                                <div className="row PasswordPage-header-row">
                                    <div className="col-xs-12">
                                        <h4>{this.getIntlMessage('passwordpage.title')}</h4>
                                    </div>
                                </div>
                                <Form role="form" className="require-validation" onKeyPress={this.keyup.bind(this)} onValidSubmit={this.changePassword.bind(this)}>

                                  <div className="form-row" style={{padding: '15px'}}>
                                    {this.getIntlMessage('changepasswordpage.change-password-description')}
                                  </div>
                                    <div className="form-row">
                                        <div className="col-xs-12 form-group card required">
                                          <label className="control-label">{this.getMessage('new-password-placeholder')}</label>
                                          <Password uppercase lowercase symbols digits noSpaces min={8} list={false} onChange={this.handleNewPasswordChange} className="new-password-input" />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="col-xs-12 form-group required">
                                            <label className="control-label">{this.getMessage('confirm-password-placeholder')}</label>
                                            <input autoComplete="off" className="new-password-input" size="20" type="password" valueLink={this.linkState('confirmPassword')} />
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="col-md-12 form-group">
                                            <button className="form-control btn btn-primary submit-button" disabled={!this.state.newPasswordValid}>{this.getIntlMessage('passwordpage.title')}</button>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

PasswordPage.defaultProps = {
    componentName: 'passwordpage'
};

const types = PasswordPage.contextTypes;
PasswordPage.contextTypes = {
    ...types,
    router: React.PropTypes.object.isRequired
};

export default PasswordPage;




// WEBPACK FOOTER //
// /src/components/PasswordPage/PasswordPage.js